import ListMail from "./ListMail";

const ErrorMail = () => {
    const urlParam = []
    urlParam['mailStatus'] = 'sending_error'

    return (
        <ListMail
            urlParam={urlParam}
            pageTitle={'mailbox.error.list.title'}
        />
    )
}


export default ErrorMail